import React from 'react';

const TableHeadContext = React.createContext();

export default TableHeadContext;